const { object, bool } = require('yup');
import translations from 'contentAlias';
import { get } from 'lodash-es';
export const declarationValidation = object().shape({
  checkboxRiskDisclosure: bool().oneOf(
    [true],
    get(
      translations,
      'customer.declaration.checkboxRiskDisclosureErrorMessage',
      ''
    )
  ),
  checkboxDeclaration: bool().oneOf(
    [true],
    get(
      translations,
      'customer.declaration.checkboxDeclarationErrorMessage',
      ''
    )
  ),
});
